import {
  IconProps,
  TextProps,
  ItemCardListProps,
  LoadingSpinnerProps, // MANUAL OVERRIDE
} from 'spindl-shared-components';


type DatabaseBlockInternalProps = {
  itemCardList?: ItemCardListProps;
  icon?: IconProps;
  title?: TextProps;
  instructions?: TextProps;
  loadingSpinner?: LoadingSpinnerProps; // MANUAL OVERRIDE
};

type DatabaseBlockPropsValues = {
  'Default': DatabaseBlockInternalProps;
  'Empty': DatabaseBlockInternalProps;
  'Loading': DatabaseBlockInternalProps; // MANUAL OVERRIDE
};

const propValues: DatabaseBlockPropsValues = {
  'Default': {
    itemCardList: {
    },
  },
  'Empty': {
    icon: {
      asset: 'Preview',
      colour: 'IconDark',
    },
    title: {
      align: 'Center',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading2',
    },
    instructions: {
      align: 'Center',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
  },
  // MANUAL OVERRIDE
  'Loading': {
    loadingSpinner: {
      size: 'Large',
      styleType: 'Primary',
    },
  },
};

const getProps = (type: string): DatabaseBlockInternalProps => {
  const values: DatabaseBlockInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
